import { AddressDto } from '@fleet-beat/core';

export function addressToString(address: AddressDto): string {
  if (!address) {
    return null;
  }

  return [
    address.line2,
    address.line1,
    address.city,
    [address.state || address.stateAbbr, address.postal].filter(Boolean).join(' '),
    address.country || address.countryAbbr,
  ]
    .filter(Boolean)
    .join(', ');
}
